const fetchApi = (route, header) => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL
  const url = `${API_BASE_URL}/${route}`

  return fetch(url, header).then((response) => response.json())
}

export default fetchApi
